// extracted by mini-css-extract-plugin
export var backdrop = "Backdrop-module--backdrop--WQmi2";